import React from 'react';
import { DiamondIcon } from './Icons';
export const UniqueMechanism = () => {
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-209">
      <div className="max-w-[720px] mx-auto" data-id="element-210">
        <h2 className="font-playfair text-[28px] md:text-[42px] text-primary text-center mb-6" data-id="element-211">
          The Discovery That Quietly Changes Everything
        </h2>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-212">
          <p className="mb-5" data-id="element-213">
            If you've felt this way for months — or years — there's something
            you may not have been told.
          </p>
          <p className="mb-5" data-id="element-214">
            Most women are never given the full picture of how their hormones
            actually work. Symptoms are treated one by one, in isolation. But
            the female body doesn't operate in pieces. It operates in rhythms.
          </p>
          <p className="mb-5" data-id="element-215">
            More women are beginning to realize something important:
          </p>
        </div>

        <div className="bg-white border-[2px] border-medium rounded-[16px] py-8 px-6 md:py-8 md:px-10 my-8 max-w-[640px] mx-auto" data-id="element-216">
          <p className="font-playfair italic text-[20px] md:text-[22px] text-primary text-center m-0" data-id="element-217">
            "Your hormones rarely fall out of balance on their own. They respond
            to the noise — and the load — your body has been carrying."
          </p>
        </div>

        <div className="font-lato text-[16px] md:text-[17px] text-body leading-[1.8]" data-id="element-218">
          <p className="mb-5" data-id="element-219">
            Years of low-grade stress. Disrupted sleep. A nervous system stuck
            in survival mode. Hidden inflammation. Environmental load from
            plastics and synthetic chemicals. A gut that re-circulates what the
            liver is trying to clear.
          </p>
          <p className="mb-5" data-id="element-220">This is not failure. This is adaptation.</p>
          <p className="mb-5" data-id="element-221">
            Your body has been working — quietly, faithfully — to keep you
            upright. To keep you functioning. To protect you in a world that has
            asked a great deal of it, for a long time.
          </p>
          <p className="mb-5" data-id="element-222">
            When the noise begins to soften, your body remembers what it has
            always known how to do: return to its own rhythm.
          </p>
        </div>

        {/* Hormonal Minimalism subsection */}
        <div className="bg-white rounded-[16px] border border-accent p-6 md:p-8 mt-8 mb-6" data-id="element-223">
          <div className="font-lato font-bold text-[12px] text-medium tracking-[0.2em] mb-3 text-center" data-id="element-224">
            A QUIETER PHILOSOPHY
          </div>
          <h3 className="font-playfair text-[24px] md:text-[28px] text-primary text-center mb-4" data-id="element-225">
            Hormonal Minimalism
          </h3>
          <p className="font-lato text-[16px] text-body leading-[1.8] text-center m-0" data-id="element-226">
            Not more supplements. Not more protocols. Not more rules to follow.
            <br className="hidden md:block" data-id="element-227" />
            <span data-id="element-228"> </span>Less of what overwhelms. More of what supports. A
            clear, simple framework your body can finally respond to.
          </p>
        </div>

        {/* Liver-Gut Axis */}
        <div className="bg-white border border-accent rounded-[16px] p-6 md:p-8 mt-6" data-id="element-229">
          <h3 className="font-playfair text-[24px] md:text-[28px] text-primary mb-6" data-id="element-230">
            The Liver–Gut Rhythm
          </h3>

          <div className="flex flex-col" data-id="element-231">
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-232">
              <div className="mt-1 flex-shrink-0" data-id="element-233">
                <DiamondIcon color="#957DAD" size={16} data-id="element-234" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-235">
                Your liver gently breaks down the hormones your body has
                finished using
              </p>
            </div>
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-236">
              <div className="mt-1 flex-shrink-0" data-id="element-237">
                <DiamondIcon color="#957DAD" size={16} data-id="element-238" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-239">
                Your gut clears them out — so they leave the body cleanly
              </p>
            </div>
            <div className="flex items-start gap-3 py-3 border-b border-[#F0EBF8]" data-id="element-240">
              <div className="mt-1 flex-shrink-0" data-id="element-241">
                <DiamondIcon color="#957DAD" size={16} data-id="element-242" />
              </div>
              <p className="font-lato text-[16px] text-body m-0" data-id="element-243">
                When that rhythm slows, old hormones don't leave the body
                efficiently — and symptoms quietly begin to build
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};